import {PaginateDraftCommand} from '@perfectpost/perfect-post-common';
import {useQuery} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {draftKeys} from '../keys';

/**
 * Le nombre de brouillons de l'utilisateur, tel que le serveur le compte
 * (`pagination.total` d'une page de taille 1).
 *
 * Remplace le `useQuery` écrit sur place dans `Profile` (clé littérale
 * `['drafts', 'count']`) pour le dialogue de suppression de compte. La liste en
 * cache ne convient pas : elle est paginée et mêle des brouillons publiés
 * invisibles dans l'interface. Toujours relu (`staleTime: 0`), et seulement
 * quand l'appelant le demande (`enabled`).
 */
export function useDraftCountQuery(options?: {enabled?: boolean}) {
  return useQuery({
    queryKey: draftKeys.count(),
    queryFn: async (): Promise<number> => {
      const {pagination} = await sendOrThrow(new PaginateDraftCommand({offset: 0, limit: 1}));
      return pagination.total;
    },
    enabled: options?.enabled ?? true,
    staleTime: 0,
  });
}
